import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 41 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M21 2H1v20h14.497a12.44 12.44 0 0 1 3.165-5.34c.72-.72 1.506-1.333 2.338-1.84V2Zm1 12.271V1H0v22h15.25a12.49 12.49 0 0 0 3.412 11.338c4.882 4.883 12.796 4.883 17.676 0 4.883-4.882 4.883-12.797 0-17.678-3.878-3.878-9.672-4.674-14.338-2.389ZM11.443 6c-1.65 0-2.716 1.077-3.355 2.004l.824.568C9.482 7.743 10.287 7 11.442 7c1.387 0 2.058.83 2.058 1.631 0 .871-.612 1.333-1.445 1.9a9.207 9.207 0 0 1-.239.156l-.023.014c-.074.048-.152.098-.229.15a2.95 2.95 0 0 0-.512.419c-.35.37-.552.855-.552 1.56v.67h1v-.67c0-.486.128-.714.28-.874a1.98 1.98 0 0 1 .342-.276c.066-.044.135-.088.21-.136l.023-.014c.082-.053.172-.11.262-.173l.039-.026c.76-.517 1.844-1.255 1.844-2.7C14.5 7.176 13.273 6 11.443 6ZM35.63 17.368c-4.49-4.49-11.77-4.49-16.262 0-4.492 4.49-4.492 11.771 0 16.263 4.491 4.492 11.773 4.492 16.262 0 4.492-4.492 4.492-11.773 0-16.263ZM20 20.5h14v1H20v-1Zm0 3h14v1H20v-1Zm0 3h14v1H20v-1Zm0 3h4v1h-4v-1Zm-8.5-14h-1v1h1v-1Z",
  fill: "#828282"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }